import css from 'styled-jsx/css';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Card from '../common/layout/Card';
import { fonts, colors } from '../common/Theme';
import { formatter } from '@yupwego/string-fns';

const MIN_DESKTOP_WIDTH = '880px';
const styles = css`
  .picture {
    height: 96px;
    width: 96px;
    border-radius: 50%;
    background-color: white;
  }
  .name {
    min-width: 30%;
    font-size: 2rem;
    margin: 15px 0 15px 0;
    text-align: center;
  }
  .description {
    align-self: flex-start;
    max-width: 100%;
    margin: 0;
    font-family: ${fonts.secondaryFont};
  }
  @media (min-width: 680px) {
    .description {
      align-self: center;
      text-align: center;
    }
  }
  .description-title {
    font-size: 1rem;
    margin-bottom: 8px;
  }
  .description-details {
    font-size: 1rem;
    font-weight: bold;
    margin-left: 0;
    margin-bottom: 16px;
    overflow-wrap: break-word;
  }

  .details-city {
    font-weight: normal;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  @media (min-width: ${MIN_DESKTOP_WIDTH}) {
    .picture {
      height: 160px;
      width: 160px;
    }
    .name {
      text-align: start;
    }
    .name-badge {
      font-size: 1.5rem;
    }
    .description {
      min-width: 20%;
      align-self: flex-end;
      text-align: start;
      margin-left: 6px;
    }
    .description-details:last-child {
      margin-bottom: 0;
    }
    .details-city {
      flex-direction: row;
      justify-content: flex-start;
      margin-bottom: 16px;
    }
    .description-city {
      margin-left: 12px;
    }
  }
  .name-badge {
    font-size: 1.125rem;
    text-align: center;
  }
`;
const profileStyles = css.resolve`
  .user-profile {
    align-items: center;
    flex-wrap: wrap;
    padding: 18px 12px;
    border-radius: 16px;
    box-shadow: 0px 0px 16px 0px ${colors.warmGrey15};
    justify-content: space-between;
  }
  @media (min-width: ${MIN_DESKTOP_WIDTH}) {
    .user-profile {
      flex-direction: row;
      padding: 32px 4%;
    }
  }
  .user-profile-badge {
    flex-direction: column;
    justify-content: center;
  }
`;

const UserProfile = ({ profile, badge }) => {
  return (
    <>
      <Card
        className={classnames('user-profile', profileStyles.className, {
          'user-profile-badge': badge
        })}
        plane
      >
        <img
          className="picture"
          src="/static/images/logo-color.svg"
          alt={`Photo de ${profile.firstname}`}
        />

        <div
          className={classnames('name', {
            'name-badge': badge
          })}
        >
          {profile.firstname} {profile.lastname}
        </div>
        {!badge ? (
          <>
            <dl className="description">
              <dt className="description-title">Date de naissance</dt>
              <dd className="description-details">
                {formatter(profile.birthday) || ' '}
              </dd>
              <dt className="description-title">Adresse mail</dt>
              <dd className="description-details">{profile.email}</dd>
              <dt className="description-title">Téléphone</dt>
              <dd className="description-details">{profile.phone || ' '}</dd>
            </dl>
            <dl className="description">
              <dt className="description-title">Adresse</dt>
              <dd className="description-details">{profile.address || ' '}</dd>
              <div className="details-city ">
                <div>
                  <dt className="description-title">Code Postal</dt>
                  <dd className="description-details">
                    {profile.postalcode || ' '}
                  </dd>
                </div>
                <div className="description-city">
                  <dt className="description-title">Ville</dt>
                  <dd className="description-details">{profile.city || ' '}</dd>
                </div>
              </div>
              <dt className="description-title">Pays de résidence</dt>
              <dd className="description-details">{profile.country || ' '}</dd>
            </dl>
          </>
        ) : null}
      </Card>
      <style jsx>{styles}</style>
      {profileStyles.styles}
    </>
  );
};

UserProfile.propTypes = {
  profile: PropTypes.object.isRequired,
  badge: PropTypes.bool.isRequired
};

UserProfile.defaultProps = {
  badge: false
};

export default UserProfile;
export { MIN_DESKTOP_WIDTH };
